module.exports = __webpack_public_path__ + "img/top-bg-basic.15b80df2.png";